import { BriefcaseBusiness } from 'lucide-react';

export const CONTAINER_ID = 'org-selector-container';

/** Statically imported, not a DynamicIcon name: that resolves through an async import() and
 *  renders null on a stale-chunk 404, which on the collapsed icon-only trigger would leave a blank
 *  but still clickable button. Shared with the Organizations nav link so the two cannot drift. */
export const OrgIcon = BriefcaseBusiness;

/** Shared by both sidebar flyouts (org selector and role switcher): right in either sidebar state,
 *  because opening upward covered the nav links stacked above the trigger. The tail entries are
 *  flip fallbacks — the DS Popover feeds `positions.slice(1)` to floating-ui, so a single-entry
 *  array leaves only `shift`, which slides back up over those same nav links. */
export const SIDEBAR_POPOVER_POSITIONS: ['right', 'left', 'bottom'] = ['right', 'left', 'bottom'];

/** Collapsed, both flyouts render inside the user-menu popover, so a 'left' flip would land the
 *  panel on top of the menu holding its own trigger. 'bottom' keeps a fallback without that. */
export const SIDEBAR_COLLAPSED_POPOVER_POSITIONS: ['right', 'bottom'] = ['right', 'bottom'];

/** floating-ui `offset()` — the trigger-to-content gap, not inner padding. The footer rows are
 *  full-width, so the trigger already ends on the sidebar's edge and any offset becomes a visible
 *  gap; 0 is what keeps the flyouts flush against it (tests/sidebar.pw.ts asserts this). */
export const POPOVER_OFFSET_PX = 0;

/** Show the search input when the org list is longer than this. The mock's own annotation: "Show
 *  search input if there are more than 10 orgs" — counted over the whole list, current org included. */
export const SEARCH_THRESHOLD = 10;

/** Max height (px) of the scrollable org list inside the popover. */
export const ORG_LIST_MAX_HEIGHT_PX = 350;
